<script lang="ts" setup>
import ButterIcon from '@/components/Icons/ButterIcon.vue'
import { useFooterData } from '@/services/seoGlobalService'

const data = useFooterData()
</script>

<template>
  <ul
    class="flex gap-[29px] lg:gap-12 1440:gap-16.5 justify-center lg:justify-start 1440:justify-center items-center mt-[44px] lg:mt-0"
  >
    <li v-for="(icon, index) in data.paymentsection_logos" :key="index">
      <ButterIcon :icon="icon.payment_logo"> </ButterIcon>
    </li>
  </ul>
</template>
